// ==============================|| PRACTICE AREA TYPES ||============================== //

import { CustomField, CustomFieldDto } from './customFields';
import { MinDto, NamedEntityMinDto } from './other';

export enum PracticeAreaType {
    PRACTICE_AREA = 'PRACTICE_AREA',
    PRACTICE_SUBAREA = 'PRACTICE_SUBAREA',
}

interface PracticeAreaMinDto extends MinDto {
    taxonomyId?: number;
}

export interface PracticeArea {
    id: number;
    isActive: boolean;
    name: string;
    practiceAreaTypeCode: PracticeAreaType;
    fullPath: string;
    parentPracticeArea?: PracticeAreaMinDto | null;
    isChildAllowed: boolean;
    depth?: number;
    customFields?: CustomField[];
    practiceGroup?: NamedEntityMinDto | null;
    practiceTeams?: NamedEntityMinDto[] | [];
    /** The list rows only: undeleted, non-draft subareas, inactive ones included. */
    subareaCount?: number;
    isAmlApplicable: boolean;
    isExcludedFromAutomaticClosing?: boolean;
    showInTimecards?: boolean;
    showInCases?: boolean;
    showInEmployees?: boolean;
    taxonomyId?: number;
    createdAt?: string;
    lastModifiedAt?: string | null;
    createdByEmployee?: MinDto;
    changedByEmployee?: MinDto;
    isDraft?: boolean;
}

export interface PracticeAreaCreateDto {
    name: string;
    isActive: boolean;
    practiceAreaTypeCode: PracticeAreaType;
    parentId: number | null;
    customFields?: CustomFieldDto[];
    practiceGroup: NamedEntityMinDto | null;
    isAmlApplicable: boolean;
    isExcludedFromAutomaticClosing?: boolean;
    /** Write-only: copies the exclusion onto every current subarea of a practice area. */
    applyExclusionToSubareas?: boolean;
    showInTimecards: boolean;
    showInCases: boolean;
    showInEmployees: boolean;
}

export interface PracticeAreaUpdateDto extends PracticeAreaCreateDto {
    id: number | string;
}

export interface PracticeAreaForm {
    name: string;
    isActive: boolean;
    practiceAreaType: PracticeAreaType;
    parent: NamedEntityMinDto | null;
    practiceGroup: NamedEntityMinDto | null;
    practiceTeams: NamedEntityMinDto[] | [];
    isAmlApplicable: boolean;
    isExcludedFromAutomaticClosing: boolean;
    applyExclusionToSubareas: boolean;
    showInTimecards: boolean;
    showInCases: boolean;
    showInEmployees: boolean;
}
